






















import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import Vue from "vue";
import { pdf_state } from "../data/pdf/state.pdf";
import { computed } from "@vue/composition-api";
import { ReportTemplateSection } from "../data/pdf/model";
export default Vue.extend({
  props: ["modalData"],
  components: { Modal },
  setup(props) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      transparentBg: true,
      width: "auto",
      // @ts-ignore
      height: "100%", //props.modalData.type == "single" ? "920px" : "80vh",
      withTopRightCloseBtn: false,
    };

    const items = computed(() => {
      // @ts-ignore
      if (props.modalData.type == "single") {
        // @ts-ignore
        const img = props.modalData.img;
        return [img];
      } else {
        // @ts-ignore
        return props.modalData.sections.map(
          (d: ReportTemplateSection) => d.runtime.a4_img
        );
      }
    });
    return {
      config,
      items,
    };
  },
});
